const defaultHeaders = {
	'Content-Type': 'application/json',
	Accept: 'application/json',
};

const request = async (url, options = {}) => {
	const response = await fetch(url, {
		headers: defaultHeaders,
		...options,
	});

	let payload = null;
	try {
		payload = await response.json();
	} catch (error) {
		payload = null;
	}

	if (!response.ok) {
		const normalizedError = {
			status: response.status,
			code: payload?.code || 'CART_API_ERROR',
			message: payload?.description || payload?.message || 'Cart API request failed',
			details: payload,
		};

		throw normalizedError;
	}

	return payload;
};

export const fetchCart = async () => {
	const res = await fetch(`/cart?view=meta.json`, {
		// cache: 'no-store',
		// headers: {
		// 	Accept: 'application/json',
		// },
	});
	const cart = await res.json();
	window.cart = cart;

	if (!res.ok) {
		throw {
			status: res.status,
			code: cart?.code || 'CART_API_ERROR',
			message: cart?.description || cart?.message || 'Cart API request failed',
			details: cart,
		};
	}

	return cart;
};

export const addItems = (items) =>
	request('/cart/add.js', {
		method: 'POST',
		body: JSON.stringify({ items }),
	});

export const changeLine = ({ id, quantity }) =>
	request('/cart/change.js', {
		method: 'POST',
		body: JSON.stringify({ id, quantity }),
	});

export const updateCart = (updates) =>
	request('/cart/update.js', {
		method: 'POST',
		body: JSON.stringify({ updates }),
	});

export const clearCart = () =>
	request('/cart/clear.js', {
		method: 'POST',
		body: JSON.stringify({}),
	});
